import { generatePath } from "react-router-dom";

import { Avatar } from "@mantine/core";
import { type ColumnDef } from "@tanstack/react-table";

import { AbsoluteRoute } from "../../../core/routes/absoluteRoutes";
import { InsightsRoundButton } from "../../../lenses/components/list/row/InsightsRoundButton";
import { LinkStyled, truncate } from "../../../shared/styles";
import { type TopPerformerLensRow } from "../../models";

import { AwardCell, PostersCell } from "./TopPerformerLensCells";
import { TopPerformerStatusChip } from "./TopPerformerStatusChip";
import { ColumnAward, ColumnIcon, ColumnName, ColumnPosters, ColumnStatus } from "./messages.generated";

export const COLUMN_NAME = "name";

export const topPerformerLensColumns: ColumnDef<TopPerformerLensRow>[] = [
    {
        id: "icon",
        header: () => <ColumnIcon />,
        cell: ({ row }) => <Avatar src={row.original.lens.iconUrl} size={36} radius="md" />,
        size: 60,
        enableSorting: false,
    },
    {
        id: COLUMN_NAME,
        header: () => <ColumnName />,
        accessorFn: (row) => row.lens.name,
        cell: ({ row, getValue }) => (
            <LinkStyled
                to={generatePath(AbsoluteRoute.LENS, { lensId: row.original.lens.id })}
                className={`paragraph-p300 ${truncate}`}
            >
                {String(getValue())}
            </LinkStyled>
        ),
        size: 240,
        enableSorting: false,
    },
    {
        id: "posters",
        header: () => <ColumnPosters />,
        cell: ({ row }) => <PostersCell row={row.original} />,
        size: 230,
        enableSorting: false,
    },
    {
        id: "status",
        header: () => <ColumnStatus />,
        cell: ({ row }) => <TopPerformerStatusChip status={row.original.status} />,
        size: 190,
        enableSorting: false,
    },
    {
        id: "award",
        header: () => <ColumnAward />,
        cell: ({ row }) => <AwardCell row={row.original} />,
        size: 150,
        enableSorting: false,
    },
    {
        id: "actions",
        header: () => null,
        cell: ({ row: { original } }) => (
            <InsightsRoundButton
                lensId={original.lens.id}
                orgId={original.lens.organizationId}
                lensFolderId={original.lens.lensAccountId?.lensSpaceId ?? undefined}
                isDisabled={false}
            />
        ),
        size: 60,
        enableSorting: false,
    },
];
